<div class="activity-feed-container">
  <div class="activity-feed-header">
    <h3 class="activity-feed-title">Recent Activity</h3>
    <button mat-icon-button class="refresh-button" matTooltip="Refresh" (click)="refreshActivity()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  
  <div class="activity-feed-content" #scrollContainer>
    <mat-progress-bar [class.invisible]="!(loading && activities.length === 0)" mode="indeterminate"></mat-progress-bar>
    
    <div class="activity-list" *ngIf="displayedActivities.length > 0">
      <div class="activity-item" *ngFor="let activity of displayedActivities">
        <div class="activity-icon" [ngClass]="getIconColorClass(activity.type)">
          <mat-icon>{{ getIcon(activity.type) }}</mat-icon>
        </div>
        <div class="activity-details">
          <div class="activity-title">{{ activity.title }}</div>
          <div class="activity-description">{{ activity.description }}</div>
          <div class="activity-time">{{ getTimeAgo(activity) }}</div>
        </div>
      </div>
    </div>
    
    <div class="empty-state" *ngIf="!loading && displayedActivities.length === 0">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <p class="empty-text">{{ error || 'No recent activity' }}</p>
    </div>
  </div>
  
  <div class="activity-feed-footer" *ngIf="activities.length > 0">
    <button mat-button color="primary" class="view-all-button" (click)="viewAllActivity()">
      View All Activity
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>